import { Command as CommandPrimitive } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils";
import { LoadingIndicator } from "../loading-indicator";
import { useCommandContext } from "./context";

export type CommandSearchProps = ComponentProps<typeof CommandPrimitive.Input>;

const Search = ({ ref, className, ...props }: CommandSearchProps) => {
  const { isLoading } = useCommandContext();
  return (
    // eslint-disable-next-line react/no-unknown-property
    <div className="relative flex items-center border-b border-neutral-90" cmdk-input-wrapper="">
      <CommandPrimitive.Input
        ref={ref}
        className={cn(
          "w-full border-none bg-transparent p-5 text-lg text-neutral-10 placeholder:text-neutral-70 focus:ring-transparent focus:outline-hidden",
          "disabled:cursor-not-allowed disabled:bg-neutral-95 disabled:text-neutral-50",
          className
        )}
        {...props}
      />
      {isLoading && (
        <div className="pr-3">
          <LoadingIndicator className="h-5 w-5 text-primary-50" />
        </div>
      )}
    </div>
  );
};

Search.displayName = CommandPrimitive.Input.displayName;

export default Search;
